import { Link } from 'react-router-dom';
import { categories, stats } from '@/mocks/data';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20cinematic%20dark%20theater%20interior%20with%20dramatic%20red%20velvet%20curtains%20and%20warm%20spotlight%20beams%2C%20luxurious%20gold%20accents%2C%20elegant%20and%20sophisticated%20atmosphere%2C%20rich%20crimson%20and%20deep%20amber%20tones%2C%20grand%20cinema%20architecture&width=1800&height=800&seq=hero-bg-main&orientation=landscape"
          alt="91麻豆官方平台"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
          正版高清内容
          <br />
          <span className="text-primary-400">一站直达</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          91麻豆汇聚海量优质原创影视资源，提供流畅高清的播放体验与安全稳定的访问渠道，满足您对高品质娱乐内容的全部需求
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/dianying"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 border border-white/40 text-white font-medium rounded-md hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            了解更多
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 flex-wrap">
          {categories.slice(0, 6).map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-1.5 text-white/70 hover:text-white transition-colors duration-200 cursor-pointer text-xs"
            >
              <i className={`${cat.icon} text-sm`}></i>
              <span>{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}